module.exports = __webpack_public_path__ + "2b0c5eae4df043a386a6e3440ef54850.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-420.jpg
// module id = 271
// module chunks = 0